import { ISearchFilter, ISearchFilterOption, ISearchFilterRangeOption } from '../../../../types';
import { IFilterResponse } from '../../types';

const mapFilters = (filtersInResp: IFilterResponse[]): ISearchFilter[] => {
  return filtersInResp.map((filterInResp: IFilterResponse) => {
    const mappedFilter: ISearchFilter = {
      identifier: filterInResp.id,
      initiallyOpen: false,
      label: filterInResp.label,
      type: null,
      displayType: null,
      options: [],
      raw: filterInResp,
      open: false,
      presentation: null
    };

    switch (filterInResp.type) {
      case 'TEXT':
        mappedFilter.type = 'MULTI_OPTION';
        mappedFilter.displayType = 'TEXT';

        mappedFilter.options = filterInResp.values.map(value => {
          return <ISearchFilterOption>{
            identifier: value.label,
            label: value.label,
            value: value.id,
            selected: false,
            active: false,
            records: value.count
          };
        });

        break;
      case 'COLOR':
        mappedFilter.type = 'MULTI_OPTION';
        mappedFilter.displayType = 'SWATCH';

        mappedFilter.options = filterInResp.values.map(value => {
          return <ISearchFilterOption>{
            identifier: value.label,
            label: value.label,
            value: value.id,
            selected: false,
            active: false,
            records: value.count,
            color: value.color
          };
        });
        break;
      case 'SIZE':
        mappedFilter.type = 'MULTI_OPTION';
        mappedFilter.displayType = 'TEXT';

        mappedFilter.options = filterInResp.sizeTypes.flatMap(sizeType => sizeType.formats.flatMap(format => format.values.map(value => {
          return <ISearchFilterOption>{
            identifier: value.label,
            label: value.label,
            value: value.id,
            selected: false,
            active: false,
            records: value.count
          };
        })));

        break;

      case 'RANGE': {
        mappedFilter.type = 'RANGE';
        mappedFilter.displayType = 'RANGE';

        let min = filterInResp.min;
        let max = filterInResp.max;
        let selMin = filterInResp.minSelected ? filterInResp.minSelected : filterInResp.min;
        let selMax = filterInResp.maxSelected ? filterInResp.maxSelected : filterInResp.max;

        // Apply localisation and B2B multiplier
        if (filterInResp.id === 'price') {
          const currencyRate = parseFloat(window.Shopify?.currency?.rate) || 1;
          const isB2B = window.theme?.isb2b === true;
          const b2bMultiplier = 0.4;
          const combinedMultiplier = isB2B ? (currencyRate * b2bMultiplier) : currencyRate;

          if (combinedMultiplier !== 1) {
            min = min * combinedMultiplier;
            max = max * combinedMultiplier;
            selMin = selMin * combinedMultiplier;
            selMax = selMax * combinedMultiplier;
          }
        }

        mappedFilter.options[0] = <ISearchFilterRangeOption>{
          minimum: min,
          maximum: max,
          selectedMinimum: selMin,
          selectedMaximum: selMax,
          activeMinimum: selMin,
          activeMaximum: selMax,
          selected: false
        };

        break;
      }
      default:
        throw new Error('Voyado filter type not implemented.');
    }

    return mappedFilter;
  });
};

export default mapFilters;
